/* eslint-disable */
import ResortEntity from '../Entity/Resort';
import EntityManager from '../EntityManager';
import ResortFactory from '../Factory/Resort';

let ResortsRepository = Backbone.Collection.extend({
	model: ResortEntity,
	addEntry:function(resorts, additionalParams) {
		var resortsModelsArray = [],
			entityManager = new EntityManager();
		
		resortsModelsArray = entityManager.add({
			factory: ResortFactory,
			repository: repository
		}, resorts, additionalParams);
		
		this.add(resortsModelsArray);
	}
});

let repository = new ResortsRepository();

repository.init = function(resorts, defaultCountrySelected) {
	var resortsModelsArray = [],
		CountriesRepository = require('../Repository/Countries').default,
		country = CountriesRepository.repository.get(defaultCountrySelected);

	_.each(resorts, function(resort) {
		resort.country = defaultCountrySelected;
		var resortModel = new ResortFactory(resort);
		resortsModelsArray.push(resortModel);
	});
	this.set(resortsModelsArray);
	
	if(defaultCountrySelected) {
		if(!country) {
			CountriesRepository.repository.add({id: defaultCountrySelected});
			country = CountriesRepository.repository.get(defaultCountrySelected)
		}
		country.set('resorts', new ResortsRepository(resortsModelsArray));
	}
};

ResortsRepository.repository = repository;

export default ResortsRepository;